(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function syncBundleState(scope) {
    var cards = (scope || document).querySelectorAll('.BDBundle__Card');

    cards.forEach(function (card) {
      var radio = card.querySelector('.BDBundle__Radio');
      card.setAttribute('data-selected', radio && radio.checked ? 'true' : 'false');
    });
  }

  function playShimmer(button) {
    if (!button || reducedMotion.matches || document.hidden) {
      return;
    }

    button.classList.remove('bd-shimmer');
    void button.offsetWidth;
    button.classList.add('bd-shimmer');
  }

  function initialiseAddToCart(button) {
    if (button.dataset.bdPolishReady === 'true') {
      return;
    }

    button.dataset.bdPolishReady = 'true';
    button.addEventListener('animationend', function (event) {
      if (event.animationName === 'bd-button-shimmer') {
        button.classList.remove('bd-shimmer');
      }
    });
    button.addEventListener('mouseenter', function () {
      playShimmer(button);
    });

    window.requestAnimationFrame(function () {
      playShimmer(button);
    });
  }

  function initialise(scope) {
    syncBundleState(scope);
    (scope || document).querySelectorAll('.ProductForm__AddToCart').forEach(initialiseAddToCart);
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('.BDBundle__Radio')) {
      syncBundleState(event.target.closest('.BDBundle'));
    }
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      document.querySelectorAll('.bd-shimmer').forEach(function (button) {
        button.classList.remove('bd-shimmer');
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    initialise(document);
  });

  document.documentElement.addEventListener('product:changed', function () {
    initialise(document);
  });
}());
